// removed by extract-text-webpack-plugin
module.exports = {"oe-numbers-table":"OeNumbersTable-module-oe-numbers-table-1reIw","oeNumbersTable":"OeNumbersTable-module-oe-numbers-table-1reIw","oe-cell":"OeNumbersTable-module-oe-cell-3KntB","oeCell":"OeNumbersTable-module-oe-cell-3KntB"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/OeNumbersTable/OeNumbersTable.module.scss
// module id = 1223
// module chunks = 0